<template>
  <m-dialog ref="dlg" @save="save" :title="model && model.id ? 'Ubah Kelas' : 'Tambah Kelas'">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation>
          <v-card flat class="pa-5 mb-5">
            <v-card-text>
              <template v-for="(item, key) in schema">
                <div :key="key">
                  <v-row wrap class="mx-2">
                    <template v-for="(form, i) in item.forms">
                      <v-col :key="i" class="my-2 py-0" v-bind="form.grid" v-if="form.vIf == null ? true : form.vIf">
                        <component v-if="form.component == 'VRadioGroup'" :is="form.component" v-model="model[form.model]" :class="form.class">
                          <template v-slot:label>
                            <div>{{ form.properties.label }}</div>
                          </template>
                          <v-radio :id="`${form.model}-${index}`" v-for="(pilih, index) in form.pilihan" :key="index" :value="pilih.value">
                            <template v-slot:label>
                              <div>{{ pilih.keterangan }}</div>
                            </template>
                          </v-radio>
                        </component>
                        <template v-else>
                          <span v-if="form.component == 'datetime' || form.component == 'wysiwyg'">{{ form.properties.label }}</span>
                          <component
                            :id="form.model"
                            :is="form.component"
                            outlined
                            dense
                            :disabled="form.properties.disabled"
                            v-bind="form.properties"
                            v-model="model[form.model]"
                            :data-vv-name="form.validation && form.validation.dataVvName ? form.validation.dataVvName : ''"
                            :data-vv-as="form.validation && form.validation.dataVvAs ? form.validation.dataVvAs : ''"
                            v-validate="form.validation && form.validation.vValidate ? form.validation.vValidate : ''"
                            :class="form.class"
                            :error-messages="form.validation && form.validation.errorMessages ? errors.collect(form.validation.errorMessages) : ''"
                          >
                            <template slot="item" slot-scope="data">
                              <div v-if="form.properties.name == 'jenis'">
                                {{ data.item.keterangan }}
                                <span>
                                  <v-chip class="mx-1" x-small :color="data.item.is_daring ? 'success' : 'warning'">{{
                                    data.item.is_daring ? "Kelas Daring" : "Kelas Luring"
                                  }}</v-chip>
                                </span>
                              </div>
                              <span v-else>{{ data.item.nama }}</span>
                            </template>
                          </component>
                        </template>
                      </v-col>
                    </template>
                  </v-row>
                </div>
              </template>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import format from "date-fns/format";
import { ALERT_INFO } from "@/const";

export default {
  provide() {
    return { parentValidator: this.$validator };
  },
  $_veeValidate: {
    validator: "new"
  },
  components: {},

  data() {
    return {
      step: 1,
      itemDiklats: [],
      itemJenises: [],
      itemAngkatans: [],
      defKelas: {
        nama: "",
        angkatan: null,
        tgl_sertifikat: null,
        jenis: null,
        url_kelas: null,
        passing_grade: 0
      },
      disableForm: false,
      alert: ALERT_INFO,
      showDiklat: true,
      model: {}
    };
  },
  computed: {
    schema() {
      return {
        schema: {
          forms: [
            {
              grid: { sm: 6, md: 6, lg: 6 },
              component: "VAutocomplete",
              model: "diklat",
              properties: {
                name: "diklat",
                label: "Pilih Diklat",
                placeholder: "Semua Diklat",
                items: this.itemDiklats,
                itemText: "nama",
                itemValue: "id",
                returnObject: true
              },
              validation: {
                dataVvname: "diklat",
                dataVvas: "Diklat",
                vValidate: "required",
                errorMessages: "form.diklat"
              },
              vIf: this.showDiklat == true
            },
            {
              grid: { sm: 6, md: 6, lg: 6 },
              component: "VAutocomplete",
              model: "jenis",
              properties: {
                name: "jenis",
                id: "jenis",
                label: "Pilih Jenis",
                placeholder: "Semua Jenis",
                autocomplete: "off",
                clearable: true,
                items: this.itemJenises,
                itemText: "keterangan",
                itemValue: "id",
                returnObject: true
              },
              validation: {
                dataVvname: "jenis",
                dataVvas: "Jenis",
                vValidate: "required",
                errorMessages: "form.jenis"
              }
            },
            {
              grid: { sm: 12, md: 6, lg: 6 },
              component: "VAutocomplete",
              model: "angkatan",
              properties: {
                name: "angkatan",
                label: "Angkatan",
                placeholder: "Isikan Angkatan",
                persistentHint: true,
                clearable: true,
                items: this.itemAngkatans,
                itemText: "nama",
                itemValue: "nomor",
                returnObject: true
              },
              validation: {
                dataVvname: "angkatan",
                dataVvas: "Angkatan",
                vValidate: "required",
                errorMessages: "form.angkatan"
              }
            },
            {
              grid: { sm: 12, md: 6, lg: 6 },
              component: "VTextField",
              model: "learndash_id",
              vIf: this.current_user && this.current_user.is_super_admin && this.model.jenis != null && this.model.jenis.is_daring == 1,
              properties: {
                name: "learndash_id",
                placeholder: "Isikan Learndash ID",
                label: "Learndash ID"
              }
            },
            {
              grid: { sm: 12, md: 6, lg: 6 },
              component: "VTextField",
              model: "singkat",
              vIf: this.current_user && this.current_user.is_super_admin && this.model.jenis != null && this.model.jenis.is_daring == 1,
              properties: {
                name: "singkat",
                placeholder: "Isikan Kode Learndash (Slug)",
                label: "Kode Learndash (Slug)"
              }
            },
            {
              grid: { cols: 12 },
              component: "VTextField",
              model: "cover",
              properties: {
                name: "cover",
                placeholder: "contoh: http://gb.storage.id/img/logo-kelas.png",
                label: "Tautan Logo Kelas"
              },
              validation: {
                dataVvname: "cover",
                dataVvas: "Logo"
              }
            },
            {
              grid: { md: 6, lg: 6 },
              component: "datetime",
              model: "tanggal_mulai",
              properties: {
                name: "tanggal_mulai",
                valueZone: "Asia/Jakarta",
                zone: "Asia/Jakarta",
                type: "datetime",
                label: "Waktu Mulai",
                disabled: this.model.is_sertifikat == true && this.model.sertifikat_jumlah_cetak > 0,
                format: {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "numeric",
                  minute: "2-digit"
                },
                phrases: { ok: "Lanjut", cancel: "Batal" }
              },
              class: "timepicker"
            },
            {
              grid: { md: 6, lg: 6 },
              component: "datetime",
              model: "tanggal_selesai",
              properties: {
                name: "tanggal_selesai",
                valueZone: "Asia/Jakarta",
                zone: "Asia/Jakarta",
                type: "datetime",
                label: "Waktu Selesai",
                disabled: this.model.is_sertifikat == true && this.model.sertifikat_jumlah_cetak > 0,
                format: {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "numeric",
                  minute: "2-digit"
                },
                phrases: { ok: "Lanjut", cancel: "Batal" }
              },
              class: "timepicker"
            },
            {
              grid: { md: 6, lg: 6 },
              component: "datetime",
              model: "tgl_mulai_daftar",
              properties: {
                name: "tanggal_mulai_daftar",
                valueZone: "Asia/Jakarta",
                zone: "Asia/Jakarta",
                type: "datetime",
                label: "Tanggal Awal Pendaftaran",
                format: {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "numeric",
                  minute: "2-digit"
                },
                phrases: { ok: "Lanjut", cancel: "Batal" }
              },
              class: "timepicker"
            },
            {
              grid: { md: 6, lg: 6 },
              component: "datetime",
              model: "tgl_selesai_daftar",
              properties: {
                name: "tgl_selesai_daftar",
                valueZone: "Asia/Jakarta",
                zone: "Asia/Jakarta",
                min_datetime: "tanggal_mulai ? new Date(tanggal_mulai).toISOString() : new Date().toISOString()",
                max_datetime: "tanggal_selesai ? new Date(tanggal_mulai).toISOString() : new Date().toISOString()",
                type: "datetime",
                label: "Tanggal Akhir Pendaftaran",
                format: {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "numeric",
                  minute: "2-digit"
                },
                phrases: { ok: "Lanjut", cancel: "Batal" }
              },
              class: "timepicker"
            },
            {
              grid: { cols: 12 },
              component: "VRadioGroup",
              model: "is_sertifikat",
              properties: {
                name: "is_sertifikat"
              },
              pilihan: [
                {
                  keterangan: "Tidak menerbitkan sertifikat",
                  value: false
                },
                {
                  keterangan: "Menerbitkan Sertifikat",
                  value: true
                }
              ]
            },
            {
              grid: { sm: 12, md: 6, lg: 6 },
              component: "VTextField",
              model: "sertifikat_nomor",
              vIf: this.model.is_sertifikat == true,
              properties: {
                name: "Nomor Sertifikat",
                placeholder: "Isikan Nomor Sertifikat",
                label: "Nomor Sertifikat",
                hint: "Isikan Nomor Sertifikat dengan benar",
                disabled: this.model.is_sertifikat == true && this.model.sertifikat_jumlah_cetak > 0
              },
              validation: {
                dataVvname: "Nomor Sertifikat",
                dataVvas: "nomor_sertifikat",
                vValidate: "required",
                errorMessages: "form.Nomor Sertifikat"
              }
            },
            {
              grid: { sm: 12, md: 6, lg: 6 },
              component: "VTextField",
              model: "sertifikat_tahun",
              vIf: this.model.is_sertifikat == true,
              properties: {
                name: "Tahun Sertifikat",
                placeholder: "Isikan Tahun Sertifikat",
                label: "Tahun Sertifikat",
                hint: "Isikan tahun sertifikat dengan benar",
                disabled: this.model.is_sertifikat == true && this.model.sertifikat_jumlah_cetak > 0
              },
              validation: {
                dataVvname: "Tahun Sertifikat",
                dataVvas: "tahun_sertifikat",
                vValidate: "required",
                errorMessages: "form.Tahun Sertifikat"
              }
            },
            {
              grid: { sm: 12, md: 6, lg: 6 },
              component: "datetime",
              vIf: this.model.is_sertifikat == true,
              model: "tgl_sertifikat",
              properties: {
                name: "tgl_sertifikat",
                valueZone: "Asia/Jakarta",
                zone: "Asia/Jakarta",
                type: "datetime",
                label: "Tanggal Terbit Sertifikat",
                format: {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "numeric",
                  minute: "2-digit"
                },
                phrases: { ok: "Lanjut", cancel: "Batal" }
              },
              class: "timepicker",
              vshow: false
            },

            {
              grid: { sm: 12, md: 6, lg: 6 },
              component: "VTextField",
              model: "url_kelas",
              vIf: this.model.jenis != null && this.model.jenis.is_daring == 0,
              properties: {
                name: "url_kelas",
                placeholder: "Link Grup WA/Telegram",
                label: "Link Grup WA/Telegram"
              },
              validation: {
                dataVvname: "url_kelas",
                dataVvas: "Link Grup WA/Telegram",
                vValidate: "required|url",
                errorMessages: "form.url_kelas"
              }
            },
            {
              grid: { sm: 12, md: 6, lg: 6 },
              component: "VTextField",
              model: "passing_grade",
              vIf: this.model.jenis != null && this.model.jenis.is_daring == 0,
              properties: {
                name: "nilai",
                placeholder: "Isikan Nilai Minimum",
                label: "Nilai Minimum (0-100)",
                hint: "Nilai minimal kelulusan peserta (0-100)"
              },
              validation: {
                dataVvname: "nilai",
                dataVvas: "Nilai Minimum",
                vValidate: "required|numeric",
                errorMessages: "form.nilai"
              }
            },
            {
              grid: { sm: 12, md: 12, lg: 12 },
              component: "wysiwyg",
              model: "keterangan",
              properties: {
                name: "keterangan",
                label: "Keterangan"
              }
            }
          ]
        }
      };
    }
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.loadDiklat();
      this.loadJenis();
      this.loadAngkatan();

      if (obj) {
        obj.is_sertifikat = obj.jenis.id_jenis_sertifikat ? true : false;
        this.model = { ...obj };
        this.model.tanggal_mulai = new Date(obj.tanggal_mulai).toISOString();
        this.model.tanggal_selesai = new Date(obj.tanggal_selesai).toISOString();
        this.model.tgl_mulai_daftar = new Date(obj.tgl_mulai_daftar).toISOString();
        this.model.tgl_selesai_daftar = new Date(obj.tgl_selesai_daftar).toISOString();
        if (this.model.tgl_sertifikat) {
          this.model.tgl_sertifikat = new Date(obj.tgl_sertifikat).toISOString();
        } else {
          this.model.tgl_sertifikat = null;
        }
      } else {
        this.model = { ...this.defKelas };
        this.model.tanggal_mulai = new Date().toISOString();
        this.model.tanggal_selesai = new Date().toISOString();
        this.model.tgl_mulai_daftar = new Date().toISOString();
        this.model.tgl_selesai_daftar = new Date().toISOString();
        this.model.tgl_sertifikat = new Date().toISOString();
      }
      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },

    // eslint-disable-next-line
    loadDiklat() {
      return this.$store
        .dispatch("diklat/get", {
          instansi_id: this.instansi_id
        })
        .then(res => {
          this.itemDiklats = res.data;
          // if (res.data.length == 1) {
          this.showDiklat = false;
          this.model.diklat = res.data[0];
          // }
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    loadAngkatan() {
      return this.$store
        .dispatch("kelas/getAngkatan", {
          instansi_id: this.instansi_id
        })
        .then(res => {
          this.itemAngkatans = res;
          // }
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    loadJenis() {
      return this.$store
        .dispatch("kelas/getJenis", this.instansi_id)
        .then(res => {
          if (this.current_user.is_super_admin) {
            this.itemJenises = res;
            this.disableForm = false;
          } else {
            this.disableForm = true;
            this.itemJenises = res.filter(jenis => jenis.is_daring == 0);
            if (this.itemJenises.length == 1) {
              this.model.jenis = this.itemJenises[0];
            }
          }
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.model.nama = this.model.jenis.keterangan;
          this.model.tanggal_mulai = format(this.model.tanggal_mulai, "YYYY-MM-DD HH:mm:ss");
          this.model.tanggal_selesai = format(this.model.tanggal_selesai, "YYYY-MM-DD HH:mm:ss");
          this.model.tgl_mulai_daftar = format(this.model.tgl_mulai_daftar, "YYYY-MM-DD HH:mm:ss");
          this.model.tgl_selesai_daftar = format(this.model.tgl_selesai_daftar, "YYYY-MM-DD HH:mm:ss");
          if (this.model.is_sertifikat == true) {
            this.model.tgl_sertifikat = format(this.model.tgl_sertifikat, "YYYY-MM-DD HH:mm:ss");
          } else {
            this.model.tgl_sertifikat = null;
          }
          return this.$store
            .dispatch("kelas/form", {
              instansi_id: this.instansi_id,
              diklat_id: this.diklat_id,
              obj: this.model
            })
            .then(res => {
              this.$refs.dlg.resolve();
              return res;
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  },
  watch: {
    tanggal_mulai(val) {
      if (val > this.tanggal_selesai) {
        this.tanggal_selesai = val;
      }
      if (val > this.model.tgl_selesai_daftar) {
        this.model.tgl_selesai_daftar = val;
      }
    }
  }
};
</script>
<style>
.timepicker {
  color: rgba(0, 0, 0, 0.87);
  padding: 9px 8px 9px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}
.vdatetime-input {
  width: 500px;
}
</style>
